export const chartTheme = {
  grid: 'rgba(148,163,184,0.18)',
  text: 'rgba(226,232,240,0.85)',
  teal: '#2DD4BF',
  seafoam: '#34D399',
  amber: '#FBBF24',
  rose: '#FB7185',
  slate: '#64748B',
};

export const tooltipStyle = {
  contentStyle: {
    backgroundColor: 'rgba(2,6,23,0.95)',
    border: '1px solid rgba(51,65,85,0.8)',
    borderRadius: '12px',
    color: '#f1f5f9',
    fontSize: '13px',
    padding: '8px 12px',
    boxShadow: '0 18px 60px rgba(0,0,0,0.45)',
  },
  itemStyle: { color: '#94a3b8' },
  labelStyle: { color: '#e2e8f0', fontWeight: 600 },
};
